import request from "../utils/request";

export default {
  createCampaignItemEvent: (key, type, value) =>
    request.post(`/campaigns/items/${key}/events`, { type, value }),
  checkCampaignItem: key => request.get(`/campaigns/items/${key}/check`)
};
